import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
@Directive({
    selector: '[cvLocalizedText]',
    inputs: ['langSection', 'langKey'],
})
export class CVLocalizedTextDirective implements AfterViewInit {
    @Input() langSection: string;
    @Input() langKey: string;

    constructor(
        private service: CVLocalizationService,
        private element: ElementRef<HTMLElement>,
    ) {
    }

    ngAfterViewInit() {
        this.loadText();
    }

    async loadText() {
        const currText = this.element.nativeElement.textContent;

        // Creating warning in case langSection and/or langKey is undefined
        const undefinedProperties = [];
        this.langSection == undefined && undefinedProperties.push('langSection');
        this.langSection == undefined && undefinedProperties.push('langKey');
        if (undefinedProperties.length > 0)
            console.warn(
                `${undefinedProperties.join(" and ")} ${undefinedProperties.length > 1 ? "are" : "is"} undefined. Default value will be used instead: ${currText}
            `);

        const text = await this.service.GetLocalText(this.langSection || "", this.langKey || "", currText);
        this.element.nativeElement.textContent = text;
    }
}
